import axios from 'axios'
// import Cookies from 'js-cookie'

// axios.interceptors.request.use(
//   config => {
//     const token = getToken()

//     if (token) {
//       config.headers = {
//         'Authorization': `Bearer ${token}`,
//       }
//     }

//     return config
//   },
//   error => Promise.reject(error)
// )

axios.interceptors.response.use(
  (response) => {
    const { config, data } = response
    return Promise.resolve(data)
  },
  // async function (error) {
  //   const { response } = error
  //   if (response.data.status.code === 401) {
  //     Cookies.remove('token-user')
  //     window.location.href = process.env.REACT_AUTHEN_BASE_URL
  //   }

  //   return Promise.reject(error)
  // }
)

// function getToken() {
//   return Cookies.get('token-user')
// }

export const axiosInterceptor = axios